import { addStore } from './stores';
function createStore() {
    let listeners = [];
    const addListener = (listener) => {
        listeners = [...listeners, listener];
    };
    const removeListener = (listener) => {
        listeners = listeners.filter(l => listener !== l);
    };
    const store = new Proxy({}, {
        set(obj, prop, value) {
            // Deferring the listeners, otherwise set state is getting called too fast
            setTimeout(() => {
                listeners.forEach(listener => {
                    listener(prop, value);
                });
            }, 0);
            return Reflect.set(obj, prop, value);
        },
    });
    addStore(store);
    return {
        store,
        addListener,
        removeListener,
    };
}
export default createStore;
//# sourceMappingURL=createStore.js.map